import {
  getCookie,
  setCookie,
  deleteCookie,
  deleteAllCookies,
} from "./cookie/cookie";
import {
  getNumberOfUniqueVisitorsData,
  helperNumberOfUniqueVisitorData,
  getUTMTermData,
} from "./mainPage";

import { handleSaveFirstTimeNudge, getNudgeData } from "./customizedNudge";
import useDragger from "./customizedNudge/useDragger";
import { handleSaveLeadCapturedNudge } from "./customizedNudge/handleSaveLeadCapturedNudge";

import handleToast from "./Toast";
import { ClassNames } from "./CSSClass/BooleanClasses";
import { getDataFromDb, updateDataInDb, deleteDataFromDb } from "./Controllers/ChatbotAPI";
import mongoDbService from "../services/mongod.data";
import { UTMdataFilter } from "./UTMGraph";
import { getPostionCSSClass } from "./CSSClass/BooleanClasses";
const { updateDataInMongoDb, getDataFromMongoDb } = mongoDbService;

export {
  getCookie,
  setCookie,
  deleteCookie,
  deleteAllCookies,
  getNumberOfUniqueVisitorsData,
  helperNumberOfUniqueVisitorData,
  getUTMTermData,
  handleSaveFirstTimeNudge,
  handleSaveLeadCapturedNudge,
  getNudgeData,
  useDragger,
  handleToast,
  ClassNames,
  getDataFromDb,
  deleteDataFromDb,
  updateDataInDb,
  updateDataInMongoDb,
  getDataFromMongoDb,
  UTMdataFilter,
  getPostionCSSClass
};
